import { useMemo } from "react";
import { IndustryItem } from "../../api/gms/group-category/group-category-api-state";

interface Props {
    industries?: IndustryItem[]
    searchValue: string;
}

export function useFilterIndustries({ industries, searchValue, }: Props) {
    return useMemo(() => {
        const search = searchValue.trim().toLowerCase();

        if (!industries) return [];
        if (!search) return industries;

        return industries.filter((industry) =>
            (industry.name ?? "").toLowerCase().includes(search)
        );
    }, [industries, searchValue])
}